import { Directive, ElementRef, HostListener, Inject, Input, LOCALE_ID, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { formatNumber, getLocaleNumberSymbol, NumberSymbol } from '@angular/common';

@Directive({
    selector: 'xena-input[number]',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: XenaDSInputNumberValueAccessorDirective, multi: true }],
    standalone: false
})
export class XenaDSInputNumberValueAccessorDirective implements ControlValueAccessor {
  @Input('number')
  public fractionDigits: number = 2;

  private value: number;
  private decimalSeparator: string;
  private thousandSeparator: string;
  private onChange: (value: number) => void;
  private onTouched: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2, @Inject(LOCALE_ID) private locale: string) {
    this.decimalSeparator = getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal);
    this.thousandSeparator = getLocaleNumberSymbol(this.locale, NumberSymbol.Group);
  }

  writeValue(value: number): void {
    this.setValue(value);
    this.renderValue();
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    this.setValue(this.parseInput(value));

    if (this.onChange) { this.onChange(this.value); }
  }

  @HostListener('valueChange')
  onValueChange(): void {
    this.renderValue();
  }

  @HostListener('xnBlur')
  onBlur(): void {
    if (this.onTouched) { this.onTouched(); }
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }

  private setValue(value: number) {
    this.value = !isNaN(value) ? value : 0;
  }

  private renderValue() {
    this.renderer.setProperty(this.el.nativeElement, 'value', formatNumber(this.value, this.locale, `.${this.fractionDigits}-${this.fractionDigits}`));
  }

  private parseInput(value: string): number {
    return parseFloat(
      value
        .replace(new RegExp(`\\${this.thousandSeparator}`, 'g'), '')
        .replace(this.decimalSeparator, '.')
    );
  }
}
